import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

import * as Sentry from '@sentry/react';

import './styles.css';
import { resetSession } from './lib/logger/client.js';
import { clientLogger } from './utils/client-logger';
import { captureInitialParamsFromUrl } from './utils/initialParams';
import { apiClient } from './api';
import { getShouldInterceptPopstate } from './utils/popstateGuard';

const sessionId = resetSession();
Sentry.setTag('mcp_session_id', sessionId);
clientLogger.setSessionId(sessionId);
const initialParams = captureInitialParamsFromUrl();
apiClient.logInitialParams({
  cid: initialParams.cid as string | undefined,
  tid: initialParams.tid as string | undefined,
  player: initialParams.player as string | undefined,
  region: initialParams.region as string | undefined,
  hasToken: !!initialParams.token,
  token: initialParams.token as string | undefined,
  rid: initialParams.rid as string | undefined,
  psid: initialParams.psid as string | undefined,
  pid: initialParams.pid as string | undefined,
  supplier_id: initialParams.supplier_id as string | undefined,
  rsid: initialParams.rsid as string | undefined,
  participant_id: initialParams.participant_id as string | undefined,
  study_id: initialParams.study_id as string | undefined,
});

window.addEventListener('popstate', async () => {
  if (!getShouldInterceptPopstate()) return;
  try {
    await apiClient.releaseSyncCapacity();
  } catch {
    // ignore
  }
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
